import axios from 'axios';

export const updateFile = async (fileId: string, fileName: string) => {
  await axios.post(`/asset/file/${fileId}`, { fileId, fileName });
};
